import React, { useState, useEffect, useRef, useCallback } from 'react';
import { api } from './api';
import { CARRIERS_MAP, PAYMENT_MAP } from './sharedConfig';

const SEGMENTO_CONFIG = {
  nuevo:      { label:'Nuevo',      color:'#3b82f6', bg:'rgba(59,130,246,0.08)' },
  recurrente: { label:'Recurrente', color:'#8b5cf6', bg:'rgba(139,92,246,0.08)' },
  vip:        { label:'VIP',        color:'#d97706', bg:'rgba(217,119,6,0.08)' },
  inactivo:   { label:'Inactivo',   color:'#9ca3af', bg:'rgba(156,163,175,0.1)' },
};
const AVATAR_COLORS = ['#6ee7b7','#93c5fd','#fca5a5','#fcd34d','#c4b5fd','#86efac','#fdba74','#67e8f9'];
const TABS = [
  { id:'todos', label:'Todos' },
  { id:'vip', label:'VIP' },
  { id:'recurrente', label:'Recurrentes' },
  { id:'nuevo', label:'Nuevos' },
  { id:'inactivo', label:'Inactivos' },
];
const fmt = (n) => new Intl.NumberFormat('es-CO',{style:'currency',currency:'COP',maximumFractionDigits:0}).format(n);
const initials = (name) => (name||'?').split(' ').slice(0,2).map(w=>(w||'')[0]).join('').toUpperCase();
const fmtDate = (d) => {
  if (!d) return '';
  const date = new Date(d);
  if (isNaN(date.getTime())) return '';
  const m = ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];
  return `${date.getDate()} ${m[date.getMonth()]}`;
};
const getOrderStatus = (o) => {
  if (o.carrier_status) {
    const s = (o.carrier_status||'').toLowerCase();
    if (s.includes('entreg')) return {label:'Entregado',color:'#16a34a'};
    if (s.includes('transito')||s.includes('ruta')) return {label:'En tránsito',color:'#d97706'};
    if (s.includes('novedad')||s.includes('devol')) return {label:'Novedad',color:'#ef4444'};
    if (s.includes('bodega')||s.includes('recog')) return {label:'En bodega',color:'#3b82f6'};
    return {label:o.carrier_status,color:'#999'};
  }
  if (o.tracking_number) return {label:'Enviado',color:'#3b82f6'};
  if (o.confirmation_status==='confirmed') return {label:'Confirmado',color:'#16a34a'};
  if (o.confirmation_status==='cancelled') return {label:'Cancelado',color:'#ef4444'};
  return {label:'Pendiente',color:'#d97706'};
};

const SortArrow = ({dir}) => (
  <svg width="8" height="8" viewBox="0 0 8 8" style={{flexShrink:0}}>
    <path d={dir==='asc'?'M4 1L7 5.5H1Z':'M4 7L1 2.5H7Z'} fill="#1a1a1a"/>
  </svg>
);
const BagIcon = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ccc" strokeWidth="1.5" strokeLinecap="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>;

const STYLES = `
.ct{--ease:cubic-bezier(0.16,1,0.3,1);--fast:120ms;--normal:200ms;--slow:300ms;flex:1;display:flex;flex-direction:column;overflow:hidden;font-family:'SF Pro Display','SF Pro Text',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;}

.ct-backdrop{position:fixed;inset:0;z-index:99;}
.ct-header{padding:20px 24px 0;flex-shrink:0;}
.ct-title-row{display:flex;align-items:flex-start;justify-content:space-between;margin-bottom:16px;}
.ct-title{font-size:22px;font-weight:700;color:#1a1a1a;letter-spacing:-0.4px;line-height:1.2;}
.ct-subtitle{font-size:13px;color:#999;margin-top:3px;}
.ct-actions{display:flex;gap:6px;align-items:center;}
.ct-btn{display:inline-flex;align-items:center;gap:5px;padding:7px 14px;border-radius:9px;border:1px solid #e0e0de;background:#fff;font-size:12.5px;font-weight:500;color:#555;cursor:pointer;font-family:inherit;transition:background var(--fast) ease,border-color var(--fast) ease,transform 80ms ease;white-space:nowrap;line-height:1;}
.ct-btn:hover{background:#f4f4f2;}
.ct-btn:active{transform:scale(0.97);}
.ct-btn-primary{background:#1a1a1a;color:#fff;border-color:#1a1a1a;}
.ct-btn-primary:hover{background:#333;}
.ct-btn-import{background:#8b5cf6;color:#fff;border-color:#8b5cf6;}
.ct-btn-import:hover{background:#7c3aed;}
.ct-btn-icon{padding:7px 8px;min-width:34px;justify-content:center;}
.ct-more-wrap{position:relative;}
.ct-more-drop{position:absolute;top:calc(100% + 6px);right:0;background:#fff;border:1px solid #e8e8e6;border-radius:10px;padding:4px;min-width:170px;z-index:200;box-shadow:0 4px 16px rgba(0,0,0,0.08);animation:ct-dropIn 150ms var(--ease) both;}
.ct-more-item{display:flex;align-items:center;gap:8px;padding:8px 10px;border-radius:7px;cursor:pointer;font-size:12.5px;color:#1a1a1a;font-weight:500;transition:background var(--fast);}
.ct-more-item:hover{background:#f4f4f2;}
@keyframes ct-dropIn{from{opacity:0;transform:translateY(-4px);}}

.ct-controls{display:flex;align-items:center;padding:0 24px;margin-bottom:2px;flex-shrink:0;gap:8px;flex-wrap:wrap;}
.ct-tabs{display:flex;gap:1px;flex-shrink:0;}
.ct-tab{font-size:12.5px;padding:8px 14px;border:none;background:transparent;color:#999;cursor:pointer;font-family:inherit;font-weight:500;border-bottom:2px solid transparent;transition:color var(--fast) ease,border-color var(--normal) ease;white-space:nowrap;}
.ct-tab:hover{color:#555;}
.ct-tab.active{color:#1a1a1a;border-bottom-color:#1a1a1a;font-weight:700;}
.ct-tab-count{margin-left:5px;font-size:10.5px;background:rgba(0,0,0,0.04);color:#aaa;padding:1px 6px;border-radius:999px;font-weight:600;}
.ct-tab.active .ct-tab-count{background:rgba(0,0,0,0.07);color:#666;}
.ct-controls-right{display:flex;align-items:center;gap:8px;margin-left:auto;}
.ct-search{display:flex;align-items:center;gap:6px;background:#f6f6f4;border:1.5px solid transparent;border-radius:9px;padding:0 10px;height:34px;width:240px;transition:border-color var(--fast) ease,box-shadow var(--fast) ease;}
.ct-search:focus-within{border-color:#d0d0ce;box-shadow:0 0 0 3px rgba(0,0,0,0.03);}
.ct-search input{background:none;border:none;outline:none;font-size:12.5px;color:#1a1a1a;font-family:inherit;width:100%;}
.ct-search input::placeholder{color:#bbb;}
.ct-search-clear{background:none;border:none;cursor:pointer;padding:2px;display:flex;opacity:0.4;transition:opacity var(--fast);}
.ct-search-clear:hover{opacity:0.8;}
.ct-btn-filter{padding:6px 10px;}
.ct-btn-filter.active{background:#1a1a1a;color:#fff;border-color:#1a1a1a;}
.ct-filter-drop{position:absolute;top:calc(100% + 6px);right:0;background:#fff;border:1px solid #e8e8e6;border-radius:10px;padding:4px;min-width:170px;z-index:200;box-shadow:0 4px 16px rgba(0,0,0,0.08);animation:ct-dropIn 150ms var(--ease) both;}
.ct-filter-title{font-size:10px;font-weight:700;color:#aaa;text-transform:uppercase;letter-spacing:0.08em;padding:4px 10px 6px;}
.ct-filter-item{display:flex;align-items:center;gap:8px;padding:7px 10px;border-radius:7px;cursor:pointer;font-size:12.5px;color:#1a1a1a;font-weight:500;transition:background var(--fast);}
.ct-filter-item:hover{background:#f4f4f2;}
.ct-filter-dot{width:8px;height:8px;border-radius:50%;flex-shrink:0;}
.ct-results{font-size:12px;color:#aaa;white-space:nowrap;}

.ct-bulk{display:flex;align-items:center;gap:8px;padding:8px 16px;background:#1a1a1a;border-radius:10px;margin:8px 24px 0;box-shadow:0 4px 20px rgba(0,0,0,0.12);animation:ct-bulkIn 200ms var(--ease) both;}
@keyframes ct-bulkIn{from{opacity:0;transform:translateY(6px);}}
.ct-bulk-info{font-size:12.5px;color:#fff;font-weight:500;}
.ct-bulk-btn{border-radius:7px;border:1px solid rgba(255,255,255,0.15);background:transparent;color:#fff;font-size:11.5px;font-weight:500;cursor:pointer;font-family:inherit;padding:5px 12px;transition:background var(--fast);}
.ct-bulk-btn:hover{background:rgba(255,255,255,0.1);}
.ct-bulk-danger{border-color:rgba(239,68,68,0.4);color:#fca5a5;}

.ct-list-area{flex:1;overflow-y:auto;overflow-x:hidden;padding:4px 24px 24px;}
.ct-head{display:grid;grid-template-columns:2.5fr 2.5fr 1fr 1fr 90px;align-items:center;padding:6px 20px 6px 20px;gap:8px;}
.ct-head-cell{font-size:10.5px;font-weight:600;color:#aaa;text-transform:uppercase;letter-spacing:0.06em;display:flex;align-items:center;gap:4px;cursor:pointer;user-select:none;white-space:nowrap;transition:color var(--fast);}
.ct-head-cell:hover{color:#666;}
.ct-cb-all{opacity:0.25;transition:opacity var(--fast);margin-right:6px;flex-shrink:0;}
.ct-cb-all:hover,.ct-cb-all:checked{opacity:1;}

.ct-row{display:grid;grid-template-columns:2.5fr 2.5fr 1fr 1fr 90px;align-items:center;padding:0 20px;min-height:68px;gap:8px;border-radius:10px;transition:background var(--fast) ease;cursor:pointer;position:relative;margin-bottom:1px;animation:ct-rowIn var(--normal) ease both;}
@keyframes ct-rowIn{from{opacity:0;transform:translateY(5px);}}
.ct-row:hover{background:rgba(0,0,0,0.022);}
.ct-row.selected{background:rgba(59,130,246,0.04);}

.ct-cell-contact{display:flex;align-items:center;gap:10px;min-width:0;}
.ct-av-wrap{width:36px;height:36px;position:relative;flex-shrink:0;}
.ct-av{width:36px;height:36px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:11.5px;font-weight:700;color:#1a1a1a;transition:opacity var(--fast);}
.ct-cb-wrap{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;opacity:0;transition:opacity var(--fast);}
.ct-row:hover .ct-cb-wrap,.ct-row.selected .ct-cb-wrap{opacity:1;}
.ct-row:hover .ct-av,.ct-row.selected .ct-av{opacity:0;}
.ct-cb{appearance:none;-webkit-appearance:none;width:17px;height:17px;border:2px solid #d0d0ce;border-radius:5px;cursor:pointer;transition:all var(--fast);position:relative;background:#fff;flex-shrink:0;}
.ct-cb:checked{background:#1a1a1a;border-color:#1a1a1a;}
.ct-cb:checked::after{content:'';position:absolute;left:4px;top:1px;width:5px;height:9px;border:solid #fff;border-width:0 2px 2px 0;transform:rotate(45deg);}
.ct-cb:hover{border-color:#999;}
.ct-contact-info{min-width:0;}
.ct-name{font-size:13px;font-weight:600;color:#1a1a1a;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
.ct-phone{font-size:11.5px;color:#999;margin-top:1px;}

.ct-cell-product{display:flex;align-items:center;gap:10px;min-width:0;}
.ct-prod-thumb{position:relative;border-radius:8px;overflow:hidden;background:#f4f4f2;flex-shrink:0;width:40px;height:40px;}
.ct-prod-ph{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;}
.ct-prod-thumb img{width:100%;height:100%;object-fit:cover;opacity:0;transition:opacity var(--slow) ease;position:relative;z-index:1;display:block;}
.ct-prod-thumb img.loaded{opacity:1;}
.ct-prod-badge{position:absolute;bottom:-1px;right:-1px;min-width:18px;height:18px;border-radius:9px;background:#1a1a1a;color:#fff;font-size:9px;font-weight:700;display:flex;align-items:center;justify-content:center;z-index:2;padding:0 4px;border:2px solid #fff;}
.ct-prod-info{min-width:0;}
.ct-prod-name{font-size:13px;color:#1a1a1a;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
.ct-prod-meta{font-size:11px;color:#aaa;margin-top:2px;white-space:nowrap;}
.ct-no-order{font-size:12px;color:#ccc;}

.ct-cell-city{font-size:13px;color:#666;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
.ct-cell-value{min-width:0;}
.ct-val{font-size:13.5px;font-weight:700;color:#1a1a1a;}
.ct-val-zero{color:#ccc;font-weight:500;}
.ct-orders-count{font-size:11px;color:#aaa;margin-top:1px;}
.ct-seg{font-size:10.5px;padding:3px 9px;border-radius:999px;font-weight:600;display:inline-flex;white-space:nowrap;transition:opacity var(--fast);}

.ct-row-dots{position:absolute;right:10px;top:50%;transform:translateY(-50%);opacity:0;transition:opacity 100ms ease;}
.ct-row:hover .ct-row-dots{opacity:1;}
.ct-dots-btn{width:28px;height:28px;border-radius:7px;border:none;background:transparent;display:flex;align-items:center;justify-content:center;cursor:pointer;transition:background var(--fast);}
.ct-dots-btn:hover{background:rgba(0,0,0,0.06);}

.ct-ctx{position:fixed;background:#fff;border:1px solid #e8e8e6;border-radius:10px;padding:4px;min-width:190px;z-index:300;box-shadow:0 4px 20px rgba(0,0,0,0.1);animation:ct-dropIn 150ms var(--ease) both;}
.ct-ctx-item{display:flex;align-items:center;gap:8px;padding:8px 10px;border-radius:7px;cursor:pointer;font-size:12.5px;color:#1a1a1a;font-weight:500;transition:background var(--fast);}
.ct-ctx-item:hover{background:#f4f4f2;}
.ct-ctx-danger{color:#ef4444;}
.ct-ctx-danger:hover{background:#fef2f2;}
.ct-ctx-sep{height:1px;background:#f0f0ee;margin:3px 6px;}

.ct-loading-more{display:flex;align-items:center;justify-content:center;padding:16px;gap:8px;color:#aaa;font-size:12.5px;}
.ct-spinner{width:16px;height:16px;border:2px solid #e8e8e6;border-top-color:#1a1a1a;border-radius:50%;animation:ct-spin 0.65s linear infinite;}
@keyframes ct-spin{to{transform:rotate(360deg)}}
.ct-footer{display:flex;align-items:center;justify-content:space-between;padding:12px 4px;font-size:12px;color:#aaa;}
.ct-all-loaded{color:#16a34a;font-weight:500;}
.ct-empty{display:flex;flex-direction:column;align-items:center;justify-content:center;padding:60px 20px;color:#ccc;gap:12px;font-size:13px;}

@keyframes ct-pulse{0%,100%{opacity:0.35}50%{opacity:0.65}}
.ct-skel{animation:ct-pulse 1.5s ease-in-out infinite;background:#e8e8e6;border-radius:6px;}
.ct-skel-circle{width:36px;height:36px;border-radius:50%;}
.ct-skel-square{width:40px;height:40px;border-radius:8px;}
.ct-skel-badge{width:56px;height:22px;border-radius:999px;}

.ct-panel-overlay{position:fixed;inset:0;background:rgba(0,0,0,0);z-index:400;transition:background var(--normal) ease;}
.ct-panel-overlay.open{background:rgba(0,0,0,0.06);}
.ct-panel{position:fixed;top:0;right:0;bottom:0;width:400px;background:#fff;z-index:401;transform:translateX(100%);transition:transform 280ms var(--ease),box-shadow 280ms ease;overflow-y:auto;overflow-x:hidden;box-shadow:none;}
.ct-panel.open{transform:translateX(0);box-shadow:-4px 0 24px rgba(0,0,0,0.06);}
.ct-panel-close{position:absolute;top:16px;right:16px;width:30px;height:30px;border-radius:8px;border:none;background:transparent;display:flex;align-items:center;justify-content:center;cursor:pointer;transition:background var(--fast);z-index:1;}
.ct-panel-close:hover{background:rgba(0,0,0,0.05);}
.ct-panel-top{padding:28px 24px 0;text-align:center;}
.ct-panel-av{width:56px;height:56px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:18px;font-weight:700;color:#1a1a1a;margin:0 auto 12px;}
.ct-panel-name{font-size:18px;font-weight:700;color:#1a1a1a;letter-spacing:-0.3px;}
.ct-panel-phone{font-size:13px;color:#999;margin-top:3px;}
.ct-panel-btns{display:flex;gap:8px;margin-top:16px;justify-content:center;}
.ct-panel-btns .ct-btn{font-size:12px;padding:8px 16px;}

.ct-panel-section{padding:0 24px;margin-top:24px;animation:ct-fadeUp var(--normal) ease both;}
@keyframes ct-fadeUp{from{opacity:0;transform:translateY(6px);}}
.ct-panel-stitle{font-size:10.5px;font-weight:700;color:#999;text-transform:uppercase;letter-spacing:0.06em;margin-bottom:10px;display:flex;align-items:baseline;}
.ct-panel-stitle-right{margin-left:auto;font-size:13px;font-weight:700;color:#1a1a1a;text-transform:none;letter-spacing:0;}
.ct-panel-row{display:flex;justify-content:space-between;padding:5px 0;}
.ct-panel-label{font-size:13px;color:#999;}
.ct-panel-val{font-size:13px;font-weight:500;color:#1a1a1a;text-align:right;max-width:60%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}

.ct-panel-order{display:flex;gap:12px;padding:10px 0;animation:ct-fadeUp var(--normal) ease both;}
.ct-panel-order+.ct-panel-order{border-top:1px solid #f6f6f4;}
.ct-panel-order-info{flex:1;min-width:0;}
.ct-panel-order-title{font-size:13px;font-weight:600;color:#1a1a1a;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
.ct-panel-order-price{font-size:14px;font-weight:700;color:#1a1a1a;margin-top:3px;}
.ct-panel-order-meta{font-size:11px;color:#aaa;margin-top:3px;display:flex;align-items:center;gap:4px;flex-wrap:wrap;}
.ct-panel-order-meta img{width:14px;height:14px;border-radius:3px;object-fit:contain;}
.ct-panel-order-status{display:inline-flex;align-items:center;gap:4px;margin-top:4px;}
.ct-status-dot{width:6px;height:6px;border-radius:50%;flex-shrink:0;}
.ct-panel-notes{font-size:13px;color:#bbb;font-style:italic;}
.ct-panel-spacer{height:32px;}

.ct-overlay{position:fixed;inset:0;background:rgba(0,0,0,0.22);backdrop-filter:blur(2px);-webkit-backdrop-filter:blur(2px);z-index:500;display:flex;align-items:center;justify-content:center;animation:ct-overlayIn var(--normal) ease both;}
@keyframes ct-overlayIn{from{opacity:0;}}
.ct-modal{background:#fff;border-radius:20px;max-height:88vh;overflow-y:auto;padding:28px;box-shadow:0 20px 60px rgba(0,0,0,0.15);animation:ct-modalIn var(--normal) var(--ease) both;}
@keyframes ct-modalIn{from{opacity:0;transform:scale(0.97) translateY(8px);}}
.ct-modal-hdr{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:20px;}
.ct-modal-title{font-size:17px;font-weight:700;color:#1a1a1a;}
.ct-modal-close{width:30px;height:30px;border-radius:8px;border:1px solid #e8e8e6;background:#f8f8f6;display:flex;align-items:center;justify-content:center;cursor:pointer;font-size:16px;color:#888;line-height:1;transition:background var(--fast);}
.ct-modal-close:hover{background:#eee;}
.ct-modal-section{font-size:10.5px;font-weight:700;color:#aaa;text-transform:uppercase;letter-spacing:0.06em;margin:16px 0 10px;}
.ct-modal-grid{display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:14px;}
.ct-modal-field label{font-size:11px;color:#999;display:block;margin-bottom:3px;font-weight:500;}
.ct-modal-field input,.ct-modal-field select{width:100%;padding:8px 10px;border-radius:8px;border:1px solid #e0e0de;font-size:13px;font-family:inherit;outline:none;color:#1a1a1a;background:#fff;transition:border-color var(--fast);}
.ct-modal-field input:focus,.ct-modal-field select:focus{border-color:#999;}
.ct-modal-submit{width:100%;padding:11px;border-radius:10px;border:none;background:#1a1a1a;color:#fff;font-size:13px;font-weight:700;cursor:pointer;font-family:inherit;margin-top:6px;transition:background var(--fast);}
.ct-modal-submit:hover{background:#333;}
.ct-import-info{background:rgba(139,92,246,0.06);border:1px solid rgba(139,92,246,0.15);border-radius:10px;padding:10px 12px;margin-bottom:16px;font-size:12px;color:#5b21b6;line-height:1.5;}
.ct-import-formats{display:flex;gap:6px;margin-bottom:14px;flex-wrap:wrap;}
.ct-import-tag{font-size:10.5px;padding:3px 9px;border-radius:999px;background:#f4f4f2;color:#555;font-weight:500;}
.ct-drop-zone{border:2px dashed #e0e0de;border-radius:14px;padding:28px;text-align:center;cursor:pointer;transition:all var(--normal) ease;}
.ct-drop-zone:hover,.ct-drop-zone.dragging{border-color:#8b5cf6;background:rgba(139,92,246,0.03);}
.ct-import-result{background:#f0fdf4;border:1px solid #bbf7d0;border-radius:12px;padding:18px;margin-bottom:14px;text-align:center;}
.ct-import-result-num{font-size:30px;font-weight:700;color:#16a34a;}
.ct-import-result-label{font-size:13px;color:#16a34a;font-weight:500;}
.ct-import-preview{display:flex;align-items:center;gap:10px;padding:7px 0;border-bottom:1px solid #f0f0ee;}
.ct-import-preview-av{width:26px;height:26px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:9.5px;font-weight:700;color:#1a1a1a;}
.ct-import-help{margin-top:14px;padding:10px 12px;background:#f8f8f6;border-radius:9px;font-size:11px;color:#888;line-height:1.6;}

@media(max-width:1100px){
  .ct-head,.ct-row{grid-template-columns:2fr 2fr 0.8fr 0.8fr 80px;}
  .ct-prod-name{max-width:130px;}
  .ct-search{width:200px;}
}
@media(max-width:900px){
  .ct-head,.ct-row{grid-template-columns:2.5fr 2fr 1fr 80px;}
  .ct-head-city,.ct-cell-city{display:none;}
  .ct-panel{width:340px;}
  .ct-search{width:170px;}
  .ct-controls{gap:6px;}
  .ct-tab{padding:8px 10px;font-size:12px;}
}
@media(max-width:600px){
  .ct-header{padding:14px 16px 0;}
  .ct-controls{padding:0 16px;}
  .ct-list-area{padding:4px 16px 16px;}
  .ct-head{display:none;}
  .ct-row{display:flex;flex-wrap:wrap;padding:12px 14px;gap:0;min-height:auto;background:#fff;border-radius:12px;margin-bottom:6px;border:1px solid #f0f0ee;}
  .ct-cell-contact{width:100%;margin-bottom:8px;}
  .ct-cell-product{width:65%;}
  .ct-cell-value{width:35%;text-align:right;display:flex;flex-direction:column;align-items:flex-end;}
  .ct-cell-city{display:none;}
  .ct-cell-seg{position:absolute;top:12px;right:14px;}
  .ct-row-dots{right:14px;top:auto;bottom:12px;transform:none;opacity:1;}
  .ct-panel{width:100%;}
  .ct-search{width:100%;}
  .ct-controls-right{width:100%;flex-wrap:wrap;}
  .ct-results{display:none;}
  .ct-bulk{margin:8px 16px 0;flex-wrap:wrap;}
  .ct-modal{width:92vw !important;padding:20px;}
}
@media(prefers-reduced-motion:reduce){
  .ct,.ct *{animation-duration:0.01ms !important;animation-iteration-count:1 !important;transition-duration:0.01ms !important;}
}
`;

export default function Contacts({ user, onNav, onLogout }) {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [nextPage, setNextPage] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  const [tab, setTab] = useState('todos');
  const [search, setSearch] = useState('');
  const [sortCol, setSortCol] = useState('nombre');
  const [sortDir, setSortDir] = useState('asc');
  const [segmentoFilter, setSegmentoFilter] = useState(null);
  const [showSegmento, setShowSegmento] = useState(false);
  const [selected, setSelected] = useState([]);
  const [menuId, setMenuId] = useState(null);
  const [menuPos, setMenuPos] = useState({top:0,left:0});
  const [moreMenu, setMoreMenu] = useState(false);
  const [detailContact, setDetailContact] = useState(null);
  const [panelOpen, setPanelOpen] = useState(false);
  const [panelOrders, setPanelOrders] = useState([]);
  const [panelOrdersLoading, setPanelOrdersLoading] = useState(false);
  const [showCreate, setShowCreate] = useState(false);
  const [showImport, setShowImport] = useState(false);
  const [importResult, setImportResult] = useState(null);
  const [importing, setImporting] = useState(false);
  const [newContact, setNewContact] = useState({nombre:'',telefono:'',ciudad:'',canal:'wa',tienda:'Tiendas Colombia',direccion:'',segmento:'nuevo'});
  const listRef = useRef(null);
  const fileInputRef = useRef(null);
  const initialLoad = useRef(true);

  useEffect(() => {
    setLoading(true);
    Promise.all([
      api.getContacts({limit:50}),
      fetch('https://talku.online/contacts/count',{headers:{'Authorization':`Bearer ${localStorage.getItem('talku_token')||''}`}}).then(r=>r.json()).catch(()=>({count:0}))
    ]).then(([data,countData]) => {
      if (data.contacts) setContacts(data.contacts);
      if (data.next_page) setNextPage(data.next_page);
      else setHasMore(false);
      if (countData.count) setTotalCount(countData.count);
      setLoading(false);
      setTimeout(() => { initialLoad.current = false; }, 400);
    }).catch(() => setLoading(false));
  }, []);

  const loadMore = useCallback(() => {
    if (loadingMore || !hasMore || !nextPage) return;
    setLoadingMore(true);
    api.getContacts({limit:50, page_info:nextPage}).then(data => {
      if (data.contacts?.length > 0) {
        setContacts(prev => {
          const ids = new Set(prev.map(c=>c.id));
          return [...prev, ...data.contacts.filter(c=>!ids.has(c.id))];
        });
      }
      if (data.next_page) setNextPage(data.next_page);
      else { setNextPage(null); setHasMore(false); }
      setLoadingMore(false);
    }).catch(() => setLoadingMore(false));
  }, [loadingMore, hasMore, nextPage]);

  const handleScroll = useCallback((e) => {
    const {scrollTop, scrollHeight, clientHeight} = e.target;
    if (scrollHeight - scrollTop - clientHeight < 200) loadMore();
  }, [loadMore]);

  const openPanel = useCallback((contact) => {
    setDetailContact(contact);
    setPanelOrders([]);
    setPanelOrdersLoading(true);
    requestAnimationFrame(() => requestAnimationFrame(() => setPanelOpen(true)));
    api.getContactOrders(contact.id).then(data => {
      setPanelOrders(data.orders || []);
      setPanelOrdersLoading(false);
    }).catch(() => setPanelOrdersLoading(false));
  }, []);

  const closePanel = useCallback(() => {
    setPanelOpen(false);
    setTimeout(() => { setDetailContact(null); setPanelOrders([]); }, 300);
  }, []);

  const handleImportCSV = async (file) => {
    if (!file) return;
    setImporting(true);
    setImportResult(null);
    try {
      const formData = new FormData();
      formData.append('file', file);
      const res = await fetch('https://talku.online/contacts/import/csv', {method:'POST', body:formData});
      const data = await res.json();
      setImportResult(data);
      if (data.contacts?.length > 0) setContacts(prev => [...data.contacts, ...prev]);
    } catch (e) {
      setImportResult({error:'Error al importar el archivo'});
    }
    setImporting(false);
  };

  const filtered = contacts.filter(c => {
    if (tab !== 'todos' && c.segmento !== tab) return false;
    if (segmentoFilter && c.segmento !== segmentoFilter) return false;
    if (search) {
      const s = search.toLowerCase();
      if (!c.nombre?.toLowerCase().includes(s) && !(c.telefono||'').includes(search) && !c.ciudad?.toLowerCase().includes(s) && !c.email?.toLowerCase().includes(s)) return false;
    }
    return true;
  }).sort((a,b) => {
    let av = a[sortCol], bv = b[sortCol];
    if (typeof av === 'string') { av = (av||'').toLowerCase(); bv = (bv||'').toLowerCase(); }
    return sortDir === 'asc' ? (av > bv ? 1 : -1) : (av < bv ? 1 : -1);
  });

  const toggleSelect = (id) => setSelected(prev => prev.includes(id) ? prev.filter(x=>x!==id) : [...prev,id]);
  const toggleAll = () => setSelected(selected.length === filtered.length ? [] : filtered.map(c=>c.id));
  const handleSort = (col) => { if (sortCol === col) setSortDir(d=>d==='asc'?'desc':'asc'); else { setSortCol(col); setSortDir('asc'); } };
  const handleNav = (id) => { if (onNav) onNav(id); };

  const exportCSV = () => {
    const rows = ['Nombre,Teléfono,Email,Ciudad,Pedidos,Valor,Segmento',
      ...filtered.map(c=>`"${c.nombre}","${c.telefono||''}","${c.email||''}","${c.ciudad||''}",${c.pedidos},${c.valor||0},${c.segmento}`)
    ].join('\n');
    const a = document.createElement('a');
    a.href = URL.createObjectURL(new Blob([rows],{type:'text/csv;charset=utf-8'}));
    a.download = 'contactos_talku.csv'; a.click();
  };

  const exportSelection = () => {
    const sel = contacts.filter(c=>selected.includes(c.id));
    const rows = ['Nombre,Teléfono,Email,Ciudad,Segmento',
      ...sel.map(c=>`"${c.nombre}","${c.telefono||''}","${c.email||''}","${c.ciudad||''}",${c.segmento}`)
    ].join('\n');
    const a = document.createElement('a');
    a.href = URL.createObjectURL(new Blob([rows],{type:'text/csv;charset=utf-8'}));
    a.download = 'seleccion_contactos.csv'; a.click();
  };

  const refresh = () => {
    setLoading(true); setContacts([]); setNextPage(null); setHasMore(true); setSelected([]);
    Promise.all([
      api.getContacts({limit:50}),
      fetch('https://talku.online/contacts/count',{headers:{'Authorization':`Bearer ${localStorage.getItem('talku_token')||''}`}}).then(r=>r.json()).catch(()=>({count:0}))
    ]).then(([data,countData]) => {
      if (data.contacts) setContacts(data.contacts);
      if (data.next_page) setNextPage(data.next_page); else setHasMore(false);
      if (countData.count) setTotalCount(countData.count);
      setLoading(false);
    }).catch(() => setLoading(false));
  };

  const closeDropdowns = () => { setMenuId(null); setShowSegmento(false); setMoreMenu(false); };

  return (
    <>
      <style>{STYLES}</style>
      <div className="ct">
        {(menuId || showSegmento || moreMenu) && <div className="ct-backdrop" onClick={closeDropdowns}/>}

        {menuId && (
          <div className="ct-ctx" style={{top:menuPos.top,left:menuPos.left}}>
            <div className="ct-ctx-item" onClick={()=>{handleNav('Conversaciones');setMenuId(null);}}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth="1.8" strokeLinecap="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
              Abrir conversación
            </div>
            <div className="ct-ctx-item" onClick={()=>{handleNav('Pedidos');setMenuId(null);}}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth="1.8" strokeLinecap="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/></svg>
              Ver pedidos
            </div>
            <div className="ct-ctx-sep"/>
            <div className="ct-ctx-item ct-ctx-danger" onClick={()=>{setContacts(prev=>prev.filter(c=>c.id!==menuId));setMenuId(null);}}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="1.8" strokeLinecap="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/></svg>
              Eliminar
            </div>
          </div>
        )}

        <div className="ct-header">
          <div className="ct-title-row">
            <div>
              <h1 className="ct-title">Contactos</h1>
              <p className="ct-subtitle">{loading ? 'Cargando...' : `${contacts.length.toLocaleString()} cargados · ${totalCount.toLocaleString()} en total`}</p>
            </div>
            <div className="ct-actions">
              <button className="ct-btn ct-btn-import" onClick={()=>setShowImport(true)}>
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
                Importar
              </button>
              <button className="ct-btn ct-btn-primary" onClick={()=>setShowCreate(true)}>
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                Crear
              </button>
              <div className="ct-more-wrap">
                <button className="ct-btn ct-btn-icon" onClick={()=>setMoreMenu(!moreMenu)}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#666" strokeWidth="2.5" strokeLinecap="round"><circle cx="12" cy="5" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="12" cy="19" r="1"/></svg>
                </button>
                {moreMenu && (
                  <div className="ct-more-drop">
                    <div className="ct-more-item" onClick={()=>{exportCSV();setMoreMenu(false);}}>
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth="1.8" strokeLinecap="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
                      Exportar CSV
                    </div>
                    <div className="ct-more-item" onClick={()=>{refresh();setMoreMenu(false);}}>
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth="1.8" strokeLinecap="round"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>
                      Actualizar
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="ct-controls">
          <div className="ct-tabs">
            {TABS.map(t => (
              <button key={t.id} className={`ct-tab${tab===t.id?' active':''}`} onClick={()=>{setTab(t.id);setSelected([]);}}>
                {t.label}
                <span className="ct-tab-count">{t.id==='todos'?contacts.length:contacts.filter(c=>c.segmento===t.id).length}</span>
              </button>
            ))}
          </div>
          <div className="ct-controls-right">
            <div className="ct-search">
              <svg width="13" height="13" viewBox="0 0 16 16" fill="none"><circle cx="7" cy="7" r="5" stroke="#bbb" strokeWidth="1.5"/><path d="M11 11l3 3" stroke="#bbb" strokeWidth="1.5" strokeLinecap="round"/></svg>
              <input placeholder="Buscar nombre, teléfono, ciudad..." value={search} onChange={e=>setSearch(e.target.value)}/>
              {search && <button className="ct-search-clear" onClick={()=>setSearch('')}><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#999" strokeWidth="2.5" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>}
            </div>
            <div style={{position:'relative'}}>
              <button className={`ct-btn ct-btn-filter${segmentoFilter?' active':''}`} onClick={()=>setShowSegmento(!showSegmento)}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>
                {segmentoFilter ? SEGMENTO_CONFIG[segmentoFilter].label : 'Segmento'}
                <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><polyline points="6 9 12 15 18 9"/></svg>
              </button>
              {showSegmento && (
                <div className="ct-filter-drop">
                  <div className="ct-filter-title">Filtrar por segmento</div>
                  <div className="ct-filter-item" onClick={()=>{setSegmentoFilter(null);setShowSegmento(false);}}>
                    <span className="ct-filter-dot" style={{background:'#ccc'}}/>Todos
                    {!segmentoFilter && <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#1a1a1a" strokeWidth="2.5" strokeLinecap="round" style={{marginLeft:'auto'}}><polyline points="20 6 9 17 4 12"/></svg>}
                  </div>
                  {Object.entries(SEGMENTO_CONFIG).map(([k,v])=>(
                    <div key={k} className="ct-filter-item" onClick={()=>{setSegmentoFilter(k);setShowSegmento(false);}}>
                      <span className="ct-filter-dot" style={{background:v.color}}/>{v.label}
                      {segmentoFilter===k && <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke={v.color} strokeWidth="2.5" strokeLinecap="round" style={{marginLeft:'auto'}}><polyline points="20 6 9 17 4 12"/></svg>}
                    </div>
                  ))}
                </div>
              )}
            </div>
            <span className="ct-results">{filtered.length} resultado{filtered.length!==1?'s':''}</span>
          </div>
        </div>

        {selected.length > 0 && (
          <div className="ct-bulk">
            <span className="ct-bulk-info">{selected.length} seleccionado{selected.length>1?'s':''}</span>
            <button className="ct-bulk-btn" onClick={()=>setSelected([])}>Deseleccionar</button>
            <button className="ct-bulk-btn" onClick={exportSelection}>Exportar selección</button>
            <button className="ct-bulk-btn">Enviar mensaje</button>
            <button className="ct-bulk-btn ct-bulk-danger" onClick={()=>{setContacts(prev=>prev.filter(c=>!selected.includes(c.id)));setSelected([]);}}>Eliminar</button>
          </div>
        )}

        <div className="ct-list-area" onScroll={handleScroll} ref={listRef}>
          <div className="ct-head">
            <div className="ct-head-cell">
              <input type="checkbox" className="ct-cb ct-cb-all" checked={selected.length===filtered.length&&filtered.length>0} onChange={toggleAll}/>
              <span onClick={()=>handleSort('nombre')} style={{cursor:'pointer',display:'flex',alignItems:'center',gap:4}}>
                Contacto {sortCol==='nombre'&&<SortArrow dir={sortDir}/>}
              </span>
            </div>
            <div className="ct-head-cell" style={{cursor:'default'}}>Último pedido</div>
            <div className="ct-head-cell ct-head-city" onClick={()=>handleSort('ciudad')}>Ciudad {sortCol==='ciudad'&&<SortArrow dir={sortDir}/>}</div>
            <div className="ct-head-cell" onClick={()=>handleSort('valor')}>Valor {sortCol==='valor'&&<SortArrow dir={sortDir}/>}</div>
            <div className="ct-head-cell" onClick={()=>handleSort('segmento')}>Segmento {sortCol==='segmento'&&<SortArrow dir={sortDir}/>}</div>
          </div>

          {loading && Array.from({length:8}).map((_,i)=>(
            <div key={i} className="ct-row" style={{animationDelay:`${i*40}ms`,cursor:'default'}}>
              <div className="ct-cell-contact" style={{gap:10}}>
                <div className="ct-skel ct-skel-circle"/>
                <div style={{display:'flex',flexDirection:'column',gap:6}}>
                  <div className="ct-skel" style={{width:110+Math.round(i*15),height:12}}/>
                  <div className="ct-skel" style={{width:90,height:10}}/>
                </div>
              </div>
              <div className="ct-cell-product">
                <div className="ct-skel ct-skel-square"/>
                <div style={{display:'flex',flexDirection:'column',gap:6}}>
                  <div className="ct-skel" style={{width:100+Math.round(i*10),height:12}}/>
                  <div className="ct-skel" style={{width:70,height:10}}/>
                </div>
              </div>
              <div className="ct-cell-city"><div className="ct-skel" style={{width:60,height:12}}/></div>
              <div className="ct-cell-value"><div className="ct-skel" style={{width:75,height:14}}/></div>
              <div><div className="ct-skel ct-skel-badge"/></div>
            </div>
          ))}

          {!loading && filtered.length===0 && (
            <div className="ct-empty">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#ddd" strokeWidth="1.3" strokeLinecap="round"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg>
              <p>No se encontraron contactos</p>
            </div>
          )}

          {!loading && filtered.map((c,idx)=>{
            const seg = SEGMENTO_CONFIG[c.segmento] || SEGMENTO_CONFIG.nuevo;
            const isSel = selected.includes(c.id);
            return (
              <div key={c.id} className={`ct-row${isSel?' selected':''}`} style={initialLoad.current?{animationDelay:`${Math.min(idx,12)*25}ms`}:undefined} onClick={()=>openPanel(c)}>
                <div className="ct-cell-contact">
                  <div className="ct-av-wrap">
                    <div className="ct-av" style={{background:AVATAR_COLORS[idx%AVATAR_COLORS.length]}}>{initials(c.nombre)}</div>
                    <div className="ct-cb-wrap" onClick={e=>e.stopPropagation()}>
                      <input type="checkbox" className="ct-cb" checked={isSel} onChange={()=>toggleSelect(c.id)}/>
                    </div>
                  </div>
                  <div className="ct-contact-info">
                    <div className="ct-name">{c.nombre}</div>
                    <div className="ct-phone">{c.telefono || '—'}</div>
                  </div>
                </div>

                <div className="ct-cell-product">
                  {c.pedidos > 0 ? (<>
                    <div className="ct-prod-thumb">
                      <div className="ct-prod-ph"><BagIcon/></div>
                      {c.ultimo_producto_img && <img src={c.ultimo_producto_img} alt="" onLoad={e=>e.target.classList.add('loaded')} onError={e=>{e.target.style.display='none'}}/>}
                      {(c.ultimo_pedido_items||0) > 1 && <span className="ct-prod-badge">+{c.ultimo_pedido_items-1}</span>}
                    </div>
                    <div className="ct-prod-info">
                      <div className="ct-prod-name">{c.ultimo_producto || `Pedido #${c.ultimo_pedido_num}`}</div>
                      <div className="ct-prod-meta">#{c.ultimo_pedido_num} · {fmtDate(c.ultima)}</div>
                    </div>
                  </>) : <span className="ct-no-order">Sin pedidos</span>}
                </div>

                <div className="ct-cell-city">{c.ciudad || '—'}</div>

                <div className="ct-cell-value">
                  <div className={`ct-val${(c.valor||0)===0?' ct-val-zero':''}`}>{(c.valor||0)>0?fmt(c.valor):'—'}</div>
                  <div className="ct-orders-count">{c.pedidos||0} pedido{(c.pedidos||0)!==1?'s':''}</div>
                </div>

                <div>
                  <span className="ct-seg" style={{background:seg.bg,color:seg.color}}>{seg.label}</span>
                </div>

                <div className="ct-row-dots" onClick={e=>{e.stopPropagation();const r=e.currentTarget.getBoundingClientRect();setMenuPos({top:r.bottom+4,left:r.right-200});setMenuId(menuId===c.id?null:c.id);}}>
                  <button className="ct-dots-btn" type="button">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#999" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="5" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="12" cy="19" r="1"/></svg>
                  </button>
                </div>
              </div>
            );
          })}

          {loadingMore && <div className="ct-loading-more"><div className="ct-spinner"/>Cargando más contactos...</div>}

          {!loading && contacts.length > 0 && (
            <div className="ct-footer">
              <span>{contacts.length.toLocaleString()} cargados de {totalCount.toLocaleString()}</span>
              {!hasMore && <span className="ct-all-loaded">Todos cargados</span>}
            </div>
          )}
        </div>

        {detailContact && (<>
          <div className={`ct-panel-overlay${panelOpen?' open':''}`} onClick={closePanel}/>
          <div className={`ct-panel${panelOpen?' open':''}`}>
            <button className="ct-panel-close" onClick={closePanel} type="button">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#999" strokeWidth="2.5" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>

            <div className="ct-panel-top">
              <div className="ct-panel-av" style={{background:AVATAR_COLORS[Math.abs((detailContact.id||0))%AVATAR_COLORS.length]}}>{initials(detailContact.nombre)}</div>
              <h2 className="ct-panel-name">{detailContact.nombre}</h2>
              <p className="ct-panel-phone">{detailContact.telefono}</p>
              <span className="ct-seg" style={{background:(SEGMENTO_CONFIG[detailContact.segmento]||SEGMENTO_CONFIG.nuevo).bg,color:(SEGMENTO_CONFIG[detailContact.segmento]||SEGMENTO_CONFIG.nuevo).color,marginTop:10,display:'inline-flex'}}>{(SEGMENTO_CONFIG[detailContact.segmento]||SEGMENTO_CONFIG.nuevo).label}</span>
              <div className="ct-panel-btns">
                <button className="ct-btn ct-btn-primary" onClick={()=>{handleNav('Conversaciones');closePanel();}}>Abrir conversación</button>
                <button className="ct-btn" onClick={()=>{handleNav('Pedidos');closePanel();}}>Ver pedidos</button>
              </div>
            </div>

            <div className="ct-panel-section" style={{animationDelay:'80ms'}}>
              <div className="ct-panel-stitle">Información</div>
              {[['Ciudad',detailContact.ciudad||'—'],['Dirección',detailContact.direccion||'—'],['Email',detailContact.email||'—'],['Canal','WhatsApp']].map(([l,v])=>(
                <div key={l} className="ct-panel-row"><span className="ct-panel-label">{l}</span><span className="ct-panel-val">{v}</span></div>
              ))}
            </div>

            <div className="ct-panel-section" style={{animationDelay:'140ms'}}>
              <div className="ct-panel-stitle">
                Pedidos ({detailContact.pedidos||0})
                {(detailContact.valor||0)>0 && <span className="ct-panel-stitle-right">{fmt(detailContact.valor)}</span>}
              </div>

              {panelOrdersLoading ? (
                <div style={{display:'flex',flexDirection:'column',gap:14}}>
                  {[1,2,3].map(i=>(
                    <div key={i} style={{display:'flex',gap:12}}>
                      <div className="ct-skel" style={{width:48,height:48,borderRadius:10,flexShrink:0}}/>
                      <div style={{display:'flex',flexDirection:'column',gap:6,flex:1}}>
                        <div className="ct-skel" style={{width:'65%',height:12}}/>
                        <div className="ct-skel" style={{width:'40%',height:14}}/>
                        <div className="ct-skel" style={{width:'50%',height:10}}/>
                      </div>
                    </div>
                  ))}
                </div>
              ) : panelOrders.length === 0 ? (
                <p className="ct-panel-notes">Sin pedidos registrados</p>
              ) : panelOrders.map((order,idx) => {
                const items = order.items || [];
                const fi = items[0] || {};
                const extra = items.length - 1;
                const carrier = CARRIERS_MAP[(order.carrier||'').toLowerCase()];
                const pm = PAYMENT_MAP[(order.payment_method||'').toLowerCase()];
                const status = getOrderStatus(order);
                return (
                  <div key={order.id} className="ct-panel-order" style={{animationDelay:`${(idx+2)*60}ms`}}>
                    <div className="ct-prod-thumb" style={{width:48,height:48,borderRadius:10}}>
                      <div className="ct-prod-ph"><BagIcon/></div>
                      {fi.image_url && <img src={fi.image_url} alt="" onLoad={e=>e.target.classList.add('loaded')} onError={e=>{e.target.style.display='none'}}/>}
                      {extra > 0 && <span className="ct-prod-badge">+{extra}</span>}
                    </div>
                    <div className="ct-panel-order-info">
                      <div className="ct-panel-order-title">{fi.title || `Pedido #${order.order_number}`}</div>
                      <div className="ct-panel-order-price">{fmt(parseFloat(order.total_price||0))}</div>
                      <div className="ct-panel-order-meta">
                        <span>#{order.order_number} · {fmtDate(order.created_at)}</span>
                        {carrier && (<>
                          <span>·</span>
                          <span style={{display:'inline-flex',alignItems:'center',gap:3}}>
                            <img src={carrier.img} alt=""/>{carrier.label}
                          </span>
                        </>)}
                        {pm && pm.label !== 'Contra entrega' && (<>
                          <span>·</span>
                          <span style={{display:'inline-flex',alignItems:'center',gap:3}}>
                            {pm.img && <img src={pm.img} alt="" style={{width:14,height:14,borderRadius:3,objectFit:'contain'}}/>}{pm.label}
                          </span>
                        </>)}
                      </div>
                      <div className="ct-panel-order-status">
                        <span className="ct-status-dot" style={{background:status.color}}/>
                        <span style={{fontSize:11,color:status.color,fontWeight:500}}>{status.label}</span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="ct-panel-section" style={{animationDelay:'200ms'}}>
              <div className="ct-panel-stitle">Notas</div>
              <p className="ct-panel-notes">Sin notas</p>
            </div>
            <div className="ct-panel-spacer"/>
          </div>
        </>)}

        {showImport && (
          <div className="ct-overlay" onClick={()=>{setShowImport(false);setImportResult(null);}}>
            <div className="ct-modal" style={{width:520}} onClick={e=>e.stopPropagation()}>
              <div className="ct-modal-hdr">
                <div className="ct-modal-title">Importar contactos</div>
                <div className="ct-modal-close" onClick={()=>{setShowImport(false);setImportResult(null);}}>×</div>
              </div>
              {!importResult ? (<>
                <div className="ct-import-info">Compatible con <strong>Bird</strong>, <strong>Shopify</strong>, <strong>Excel</strong> y cualquier CSV. Las columnas se mapean automáticamente.</div>
                <div className="ct-modal-section">Formatos soportados</div>
                <div className="ct-import-formats">
                  {['Bird CSV','Shopify Customers','Excel exportado','WhatsApp contacts','Custom CSV'].map(f=><span key={f} className="ct-import-tag">{f}</span>)}
                </div>
                <input ref={fileInputRef} type="file" accept=".csv,.txt" style={{display:'none'}} onChange={e=>{if(e.target.files[0])handleImportCSV(e.target.files[0]);}}/>
                <div className={`ct-drop-zone${importing?' dragging':''}`}
                  onClick={()=>fileInputRef.current?.click()}
                  onDragOver={e=>{e.preventDefault();e.currentTarget.classList.add('dragging');}}
                  onDragLeave={e=>e.currentTarget.classList.remove('dragging')}
                  onDrop={e=>{e.preventDefault();e.currentTarget.classList.remove('dragging');const f=e.dataTransfer.files[0];if(f)handleImportCSV(f);}}
                >
                  {importing ? (
                    <div style={{display:'flex',flexDirection:'column',alignItems:'center',gap:10}}>
                      <div className="ct-spinner" style={{width:24,height:24,borderWidth:3}}/>
                      <div style={{fontSize:13,color:'#888'}}>Procesando archivo...</div>
                    </div>
                  ) : (<>
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="1.5" strokeLinecap="round" style={{marginBottom:8}}><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
                    <div style={{fontSize:14,fontWeight:700,color:'#1a1a1a',marginBottom:3}}>Arrastra tu CSV aquí</div>
                    <div style={{fontSize:12,color:'#aaa'}}>o haz clic para seleccionar</div>
                  </>)}
                </div>
                <div className="ct-import-help">
                  <strong>Bird:</strong> Contactos → Exportar → CSV<br/>
                  <strong>Shopify:</strong> Clientes → Exportar → Todos los clientes<br/>
                  <strong>Mínimo requerido:</strong> nombre O teléfono O email
                </div>
              </>) : (
                <div>
                  {importResult.error ? (
                    <div style={{background:'#fef2f2',border:'1px solid #fee2e2',borderRadius:10,padding:14,color:'#ef4444',fontSize:13}}>{importResult.error}</div>
                  ) : (<>
                    <div className="ct-import-result">
                      <div className="ct-import-result-num">{importResult.importados?.toLocaleString()}</div>
                      <div className="ct-import-result-label">contactos importados</div>
                      {importResult.errores > 0 && <div style={{fontSize:12,color:'#d97706',marginTop:6}}>{importResult.errores} filas con errores ignoradas</div>}
                    </div>
                    <div className="ct-modal-section">Vista previa</div>
                    {importResult.contacts?.map((c,i)=>(
                      <div key={i} className="ct-import-preview">
                        <div className="ct-import-preview-av" style={{background:AVATAR_COLORS[i%AVATAR_COLORS.length]}}>{initials(c.nombre)}</div>
                        <div>
                          <div style={{fontSize:12,fontWeight:700,color:'#1a1a1a'}}>{c.nombre}</div>
                          <div style={{fontSize:11,color:'#aaa'}}>{c.telefono||c.email||'—'}</div>
                        </div>
                      </div>
                    ))}
                  </>)}
                  <button className="ct-modal-submit" onClick={()=>{setShowImport(false);setImportResult(null);}}>Cerrar</button>
                </div>
              )}
            </div>
          </div>
        )}

        {showCreate && (
          <div className="ct-overlay" onClick={()=>setShowCreate(false)}>
            <div className="ct-modal" style={{width:480}} onClick={e=>e.stopPropagation()}>
              <div className="ct-modal-hdr">
                <div className="ct-modal-title">Nuevo contacto</div>
                <div className="ct-modal-close" onClick={()=>setShowCreate(false)}>×</div>
              </div>
              <div className="ct-modal-section">Datos personales</div>
              <div className="ct-modal-grid">
                {[{k:'nombre',l:'Nombre completo',ph:'María Rodríguez'},{k:'telefono',l:'Teléfono WhatsApp',ph:'+57 300 000 0000'},{k:'ciudad',l:'Ciudad',ph:'Bogotá'},{k:'direccion',l:'Dirección',ph:'Cra 15 #82-45'}].map(f=>(
                  <div key={f.k} className="ct-modal-field"><label>{f.l}</label><input value={newContact[f.k]} onChange={e=>setNewContact({...newContact,[f.k]:e.target.value})} placeholder={f.ph}/></div>
                ))}
              </div>
              <div className="ct-modal-section">Configuración</div>
              <div className="ct-modal-grid">
                <div className="ct-modal-field"><label>Canal</label><select value={newContact.canal} onChange={e=>setNewContact({...newContact,canal:e.target.value})}><option value="wa">WhatsApp</option><option value="ig">Instagram</option><option value="fb">Facebook</option></select></div>
                <div className="ct-modal-field"><label>Tienda</label><select value={newContact.tienda} onChange={e=>setNewContact({...newContact,tienda:e.target.value})}>{['Tiendas Colombia','Trend Bird','Tokio Tienda'].map(t=><option key={t}>{t}</option>)}</select></div>
                <div className="ct-modal-field"><label>Segmento</label><select value={newContact.segmento} onChange={e=>setNewContact({...newContact,segmento:e.target.value})}>{Object.entries(SEGMENTO_CONFIG).map(([k,v])=><option key={k} value={k}>{v.label}</option>)}</select></div>
              </div>
              <button className="ct-modal-submit" onClick={()=>{
                if(!newContact.nombre||!newContact.telefono)return;
                setContacts(prev=>[{id:Date.now(),...newContact,pedidos:0,valor:0,ultima:'hoy',email:'',canal:newContact.canal,fuente:'manual'},...prev]);
                setShowCreate(false);
                setNewContact({nombre:'',telefono:'',ciudad:'',canal:'wa',tienda:'Tiendas Colombia',direccion:'',segmento:'nuevo'});
              }}>Crear contacto</button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
